var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ies-field" },
    [
      _vm.field.schema && _vm.field.schema.displayName !== "none"
        ? _c(
            "div",
            { staticClass: "ies-field__label mb-1" },
            [
              _c(
                "label",
                {
                  staticClass: "font-weight-heavy",
                  attrs: { for: _vm.field.fieldName },
                },
                [
                  _vm._v(
                    "\n            " + _vm._s(_vm.field.schema.displayName)
                  ),
                  _vm.field.required
                    ? _c(
                        "span",
                        {
                          staticClass: "red--text ml-1",
                          attrs: { title: "Required" },
                        },
                        [_vm._v("*")]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _vm.hasValidation
                ? _c(
                    "v-icon",
                    {
                      staticClass: "ml-1",
                      staticStyle: {
                        cursor: "pointer",
                        "vertical-align": "middle",
                      },
                      attrs: { small: "", title: "Show validation rules" },
                      on: {
                        click: function ($event) {
                          _vm.showValidationGuide = !_vm.showValidationGuide
                        },
                      },
                    },
                    [_vm._v("info_outline")]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showValidationGuide && _vm.hasValidation
        ? _c(
            "v-alert",
            { staticClass: "mb-2", attrs: { type: "info", dense: "" } },
            _vm._l(_vm.field.validation, function (rule, i) {
              return _c("div", { key: i }, [
                _vm._v(_vm._s(_vm.ruleAsString(rule))),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.field.introduction
        ? _c("div", { staticClass: "body-2 grey--text text--darken-1 mb-2" }, [
            _vm._v(_vm._s(_vm.field.introduction)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.field.information
        ? _c(
            "v-alert",
            {
              staticClass: "mb-2",
              attrs: { type: "info", dense: "", dismissible: "" },
            },
            [_vm._v(_vm._s(_vm.field.information))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.warningText
        ? _c(
            "v-alert",
            {
              staticClass: "mb-2",
              attrs: { type: "warning", dense: "", dismissible: "" },
            },
            [_vm._v(_vm._s(_vm.warningText))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.normalisedErrors.length
        ? _c(
            "v-alert",
            { staticClass: "mb-2", attrs: { type: "error", dense: "" } },
            _vm._l(_vm.normalisedErrors, function (msg, i) {
              return _c("div", { key: i }, [_vm._v(_vm._s(msg))])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }